<form autofocus [formGroup]="form" (ngSubmit)="unconfirm()">
    <div class="modal-header">
        <h4 class="modal-title">{{ title | translate }}</h4>
        <button class="close" type="button" aria-label="Close" (click)="activeModal.close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="row card-border-top">
            <div class="card-body col">
                <div class="row">
                    <div class="col">
                        <form-textbox
                            labelText="{{ 'Count of containers' | translate }}"
                            formControlName="containerCount"></form-textbox>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <form-textbox
                            labelText="{{ 'Service Request Number' | translate }}"
                            formControlName="serviceRequestId"></form-textbox>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <form-textbox
                            labelText="{{ 'Manipulation' | translate }}"
                            formControlName="manipulation"></form-textbox>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <form-textbox labelText="{{ 'Remark' | translate }}" formControlName="remark"></form-textbox>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button class="btn btn-sm btn-danger mr-2" type="submit" translate [disabled]="form.invalid">
            <fa-icon [icon]="['fas', 'ban']"></fa-icon>
            &nbsp;&nbsp;{{ 'Unconfirm' | translate }}
        </button>
        <button class="btn btn-sm btn-secondary" type="button" translate (click)="activeModal.close(null)">
            <fa-icon [icon]="['fas', 'times']"></fa-icon>
            &nbsp;&nbsp;{{ 'Cancel' | translate }}
        </button>
    </div>
</form>
